enum Role {
  CLIENT_USER = 'client_user',
  CLIENT_ADMINISTRATOR = 'client_administrator',
  SUPER_USER = 'super_user',
}

export default Role;
